import { CertificationProviderTypeEnum } from '../enums/certification-provider-type.enum';

export class CertificationProviderCommand {
    name: string;
    type: CertificationProviderTypeEnum;

    constructor(name: string, type?: CertificationProviderTypeEnum) {
        this.name = name;
        if (type !== undefined) {
            this.type = type;
        }
    }
}
